module.exports = "<app-main></app-main>\n<router-outlet></router-outlet>\n"